import { useState } from 'react';
import { AudioProgressBar } from '@/components/audio/shared/AudioProgressBar';
import { AudioBigControls } from '@/components/audio/shared/AudioBigControls';
import { AudioMiniControls } from '@/components/audio/shared/AudioMiniControls';
import { SchlafTimerSheet } from '@/components/audio/nowplaying/SchlafTimerSheet';
import { useAudioStore } from '@/stores/audioStore';

/**
 * Inline catalog-Folge player. Mirrors CombinedAudioPlayer (the series Gesamt-
 * Hörbuch): a non-story TrackKind that is deliberately absent from the
 * MiniPlayer and controlled from its own route surface. Renders only when a
 * catalog Folge is the active track (kind === 'catalog'); otherwise null.
 *
 * Composed from the SAME shared, kind-agnostic primitives the single-story
 * inline player uses — AudioProgressBar (scrub + total time, fed by the
 * catalog audioDurationS now threaded into the store), AudioBigControls
 * (play/pause + ±15), AudioMiniControls (speed + Schlaf-Timer + download).
 */
export function CatalogInlineAudioPlayer() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const kind = useAudioStore((s) => s.kind);
  const title = useAudioStore((s) => s.title);

  if (kind !== 'catalog') return null;

  return (
    <>
      <div className="flex flex-col items-center gap-2.5 overflow-hidden rounded-lg bg-gradient-to-t from-dream-navy to-world-aa px-8 pt-8 pb-8">
        {title && (
          <p className="text-center text-base font-medium leading-none text-dream-white md:text-xl">
            {title}
          </p>
        )}
        <AudioProgressBar className="md:max-w-[468px]" />
        <AudioBigControls />
        <AudioMiniControls onSchlafTimerClick={() => setSheetOpen(true)} />
      </div>

      <SchlafTimerSheet open={sheetOpen} onOpenChange={setSheetOpen} />
    </>
  );
}
